// extracted by mini-css-extract-plugin
module.exports = {"navMenu":"DesktopMenu_navMenu__ILNVg","navItem":"DesktopMenu_navItem__ee8Zn","navItemActive":"DesktopMenu_navItemActive__9w6w6","navLink":"DesktopMenu_navLink__IEboP"};